import axios, {AxiosError} from 'axios';
import ENDPOINTS from '../constants/apiEndPoints';

export type ApiError = {message?: string; errors?: string[]};

export type ApiResponse<T> = {
  data: T;
  success: boolean;
  message: string;
};

export function getAxiosErrorMessage(err: unknown): string {
  const ax = err as AxiosError<ApiError>;
  return (
    ax?.response?.data?.errors?.join('\n') ||
    ax?.response?.data?.message ||
    ax?.message ||
    'משהו השתבש'
  );
}

// Create an Axios instance for authenticated requests
export const axiosInstance = axios.create({
  baseURL: ENDPOINTS.BASE_URL,
  timeout: 30000,
  headers: {
    'ngrok-skip-browser-warning': 'true',
    'Content-Type': 'application/json',
  },
});

// Request interceptor for authenticated requests
axiosInstance.interceptors.request.use(
  config => {
    const token = localStorage.getItem('userToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  },
);

// Response interceptor: auto-logout on 401
axiosInstance.interceptors.response.use(
  response => response,
  error => {
    const ax = error as AxiosError;

    if (ax.response?.status === 401) {
      localStorage.clear();
      window.location.reload();
    }

    return Promise.reject(error);
  },
);
